import CropFreeIcon from '@material-ui/icons/CropFree';

import { ScannerLogsList } from './List/List';

export {
	ScannerLogsList,
};

export const scannerLogsResource = {
	list: ScannerLogsList,
	icon: CropFreeIcon,
};
